import moment from "moment";

const calcSeason = async (seassons, moment_date) => {

    if (moment_date != "") {
        try {
            var seasons_days = [];
            var season_today = {};

            var fecha = moment_date.set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
            });

            var ano = moment().format("YYYY");

            for (let s of seassons) {
                if (s.id == "PEAK") {
                    s.color = "#f0341f";
                } else if (s.id == "HIGH") {
                    s.color = "#ffb748";
                } else if (s.id == "MID") {
                    s.color = "#fbed63";
                } else if (s.id == "LOW") {
                    s.color = "#6ac6f9";
                }

                s.dates = JSON.parse(s.dates);

                if (s.dates.length > 0) {
                    for (var d of s.dates) {
                        var desde = moment(ano + "/" + d.from, "YYYY/MM/DD");
                        var hasta = moment(ano + "/" + d.to, "YYYY/MM/DD");
                        if (hasta < desde) {
                            hasta = moment(parseInt(ano) + 1 + "/" + d.to, "YYYY/MM/DD");
                        }
                        var cant = hasta.diff(desde, "days");
                        for (let i = 0; i <= cant; i++) {
                            var d_temp = i == 0 ? desde : desde.add(1, "days");

                            if (fecha.format("YYYYMMDD") == desde.format("YYYYMMDD")) {
                                season_today = {
                                    month: d_temp.format("M"),
                                    day: d_temp.format("DD"),
                                    code: d_temp.format("MDD"),
                                    season: s.name,
                                    id: s.id,
                                    color: s.color,
                                };
                                //console.log("ACA PEGA ");
                            }
                            seasons_days.push({
                                month: d_temp.format("M"),
                                day: d_temp.format("DD"),
                                code: d_temp.format("MDD"),
                                season: s.name,
                                id: s.id,
                                color: s.color,
                            });
                        }
                    }
                }
            }
            return season_today.id;
        } catch (error) {
            console.log(error);
        }
    }
};

const getSeason = async (_data) => {
    try {
        //console.log(_data)
        let seasons_string = [{ name: "PEAK", bloques: [] }, { name: "HIGH", bloques: [] }, { name: "MID", bloques: [] }, { name: "LOW", bloques: [] }];
        let seasons_days = [];
        let season_today = {};
        let season_obj = {};
        let fecha = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        let ano = moment().format("YYYY");

        for (let _s of _data) {

            let pos_string = seasons_string.findIndex(ss => _s.id == ss.name)

            if (_s.id == "PEAK") {
                _s.color = "#f0341f";
            } else if (_s.id == "HIGH") {
                _s.color = "#ffb748";
            } else if (_s.id == "MID") {
                _s.color = "#fbed63";
            } else if (_s.id == "LOW") {
                _s.color = "#6ac6f9";
            }

            _s.dates = JSON.parse(_s.dates);

            if (_s.dates.length > 0) {
                for (let d of _s.dates) {
                    seasons_string[pos_string].bloques.push(d.from_label.replace("/", " ") + " - " + d.to_label.replace("/", " "))
                    let desde = moment(ano + "/" + d.from, "YYYY/MM/DD");

                    if (isNextYear(d.from) && isNextYear(d.to)) {
                        desde = moment(parseInt(ano) + 1 + "/" + d.from, "YYYY/MM/DD");
                    }

                    let hasta = moment(desde.year() + "/" + d.to, "YYYY/MM/DD");

                    if (hasta.isBefore(desde, "day")) {
                        hasta = moment(parseInt(desde.year()) + 1 + "/" + d.to, "YYYY/MM/DD");
                    }

                    let cant = hasta.diff(desde, "days");
                    for (let i = 0; i <= cant; i++) {
                        let d_temp = i == 0 ? desde : desde.add(1, "days");
                        if (fecha.format("YYYYMMDD") == desde.format("YYYYMMDD")) {
                            season_today = {
                                month: d_temp.format("M"),
                                day: d_temp.format("DD"),
                                code: d_temp.format("MDD"),
                                season: _s.name,
                                id: _s.id,
                                color: _s.color,
                            };
                        }
                        season_obj[d_temp.format("MMDD")] = _s.id;

                        seasons_days.push({
                            month: d_temp.format("M"),
                            day: d_temp.format("DD"),
                            code: d_temp.format("MDD"),
                            season: _s.name,
                            id: _s.id,
                            color: _s.color,
                        });
                    }
                }
            }
        }
        let sess_arr = []
        for (let sst of seasons_string) {
            sess_arr.push("<em>" + sst.name + "</em>: " + sst.bloques.join(" | "))
        }
        let sess_string = sess_arr.join(" &nbsp; ")
        return [season_obj, sess_string, seasons_days];
    } catch (error) {
        console.log(error)
    }
};

const isNextYear = (date_month) => {
    const today = moment()
    const currentYearDate = moment(`${today.year()}-${date_month}`, "YYYY-MM-DD");
    return today.isAfter(currentYearDate)
};

const calcNights = (checkIn, checkOut) => {
    if (checkOut && checkIn && checkOut.diff(checkIn, "days") > 0) {
        return checkOut.diff(checkIn, "days") || 0;
    }

    return 0;
};

const seasonGuestsPrice = (prices, guests, season) => {
    if (prices) {
        for (let i = 0; i < prices.length; i++) {
            const item = prices[i];
            if (item.guests === parseInt(guests)) {
                switch (season) {
                    case "PEAK":
                        return item.pricePeak;
                    case "HIGH":
                        return item.priceHigh;
                    case "MID":
                        return item.priceMid;
                    case "LOW":
                        return item.priceLow;
                    default:
                        break;
                }
            }
        }
    }
    return 0;
};

const seasonExtrasPrice = (option, season) => {
    switch (season) {
        case "PEAK":
            return option.pricePeak;
        case "HIGH":
            return option.priceHigh;
        case "MID":
            return option.priceMid;
        case "LOW":
            return option.priceLow;
        default:
            return 0;
    }
};

const perGuest = (cost, guests) => Math.ceil(cost / guests);
const perNight = (cost, nights) => Math.ceil(cost / nights);
const afterTaxes = (cost, percentage) =>
    Math.ceil(cost + (cost * percentage) / 100);

const calcRoomPrices = (prices, guests, season, nights) => {
    const roomPN = seasonGuestsPrice(prices, guests, season);
    const room = roomPN * nights;
    const roomPG = perGuest(room, guests);

    return {
        room,
        roomPN,
        roomPG,
    };
};

const buscaSeasonXDia = (_seasons,_checkInSeason, _checkOutSeason) => {
    //console.log(_seasons,_checkInSeason, _checkOutSeason)
    
    if (_checkInSeason != "" && _seasons) {
        //console.log("entro")
        let puntero = _checkInSeason.clone(),
            ses = { dias: [], ses: {} };
        //console.log(_checkOutSeason.diff(_checkInSeason, "days"))
        while (puntero.isBefore(_checkOutSeason)) {
            let s = _seasons[puntero.format("MMDD")];
            ses.ses[s] = ses.ses.hasOwnProperty(s) ? ses.ses[s] + 1 : 1
            ses.dias.push({
                date: puntero.format("DD/MM/YYYY"),
                season: s,
            });
            puntero.add(1, "days");
        }
        //console.log(ses);
        return ses;
    } else {
        return "";
    }
};

const calcRoomPricesXdia = (prices, guests, _seasons) => {
    if (prices == 0) {
        return { room: 0, roomPN: 0, roomPG: 0, seasons: null }
    } else {
        let dias_season = []
        let total = 0
        if (prices && _seasons) {
            var pricexcantguest = prices.find((r) => parseInt(r.guests) === parseInt(guests));
            //SI NO TIENE PARA LA CANTIDAD DE GUEST TOMA EL MENOR...UNO DE LOS CUARTOS TIENE A PARTIR DE 5 GUESTS
            pricexcantguest = (pricexcantguest) ? pricexcantguest : prices[0]
            for (let d of _seasons.dias) {
                let dia_temp = Object.assign({}, d)
                let t_label = "price" + dia_temp.season.charAt(0).toUpperCase() + dia_temp.season.slice(1).toLowerCase()
                let p = pricexcantguest[t_label];
                dia_temp.precio = p;
                total = total + p;
                dias_season.push(dia_temp)
            }

            let s = {
                ses: _seasons.ses,
                total,
                dias: dias_season
            }

            const roomPN = Math.ceil(total / dias_season.length);
            const room = total;
            const roomPG = perGuest(total, guests);

            return {
                room,
                roomPN,
                roomPG,
                seasons: s
            };
        }
    }
};

const calcExtraPrice = (extra, guests) => extra.price * extra.amount * guests;

const calcTamborPrice = (tambor, guests, config) => {
    let total = tambor.price * tambor.amount;
    if (guests > config.tambor_max_guests) {
        total =
            (tambor.price +
                config.tambor_extra_guest_cost * (guests - config.tambor_max_guests)) *
            tambor.amount;
    }
    return total;
};

const calcDiscount = (roomCosts, otherCosts, promoCode) => {
    let discount = 0;
    //console.log(roomCosts, otherCosts, promoCode)
    if (promoCode) {
        let total = promoCode.only_rooming ? roomCosts : roomCosts + otherCosts;
        switch (promoCode.type) {
            case "PERCENT":
                discount = (total * promoCode.discount) / 100;
                break;
            case "AMOUNT":
                discount = total > promoCode.discount ? promoCode.discount : total;
                break;
            default:
                break;
        }
    }
    return discount;
};

const getRoomGallery = (room, largeImage = false) => {
    let gallery = [];
    //console.log(room)

    gallery.push(largeImage && room.image_large ? room.image_large : room.image);

    gallery = gallery.concat(
        room.photos.map((photo) =>
            largeImage && photo.image_large ? photo.image_large : photo.image
        )
    );

    gallery.push(
        largeImage && room.hotel_image_large
            ? room.hotel_image_large
            : room.hotel_image
    );

    gallery = gallery.concat(
        room.hotel_photos.map((photo) =>
            largeImage && photo.image_large ? photo.image_large : photo.image
        )
    );

    return gallery;
};

const getPackGallery = (room, pack, largeImage = false) => {
    let gallery = getRoomGallery(room, largeImage);

    gallery = gallery.concat(
        pack.photos.map((photo) =>
            largeImage && photo.image_large ? photo.image_large : photo.image
        )
    );

    return gallery;
};

const jumpTo = (elementId, offset = 0) => {
    if (elementId && document && typeof document !== 'undefined' ) {
    if (window.innerWidth < 768 || elementId.startsWith("step")) {
        setTimeout(() => {
            if(document.getElementById(elementId)) window.scroll({
                top: document.getElementById(elementId).offsetTop - offset,
                left: 0,
                behavior: "smooth",
                block: "end",
            });
        }, 500);
    }}
};

const keyboardActive = () => {
    document.getElementById("react_root").className = "mobile_keyboard_active";
    const keyboard = document.getElementById("mobile_keyboard");
    if (keyboard) {
        keyboard.style.display = "block";
    }
};
const keyboardHidden = () => {
    document.getElementById("react_root").className = "";
    const keyboard = document.getElementById("mobile_keyboard");
    if (keyboard) {
        keyboard.style.display = "none";
    }
};

const printContents = (elementId) => {
    let printContents = document.getElementById(elementId).innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
};

const seteaCifra = (sigla, cifra) => {
    //console.log(cifra)
    const cifra_label = typeof cifra === "string" ? parseFloat(cifra).toFixed(2) : cifra.toFixed(2)

    return (cifra >= 0) ?
        sigla + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cifra)
        :
        sigla + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cifra)
    //<span style={{ color: "#BD162C" }} > {sigla} {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(cifra)}</span>
}


const calculaPorcentaje = (_monto, _porcentaje, _moneda = "") => {
    // multiplicar x 1,13 1.porcentaje
    const subtotal = _porcentaje === 0 ? _monto : _monto / (1 + (_porcentaje / 100))
    const tax = _porcentaje === 0 ? 0 : (subtotal * _porcentaje) / 100
    return [
        subtotal,
        tax,
        String(seteaCifra(_moneda, subtotal)),
        String(seteaCifra(_moneda, tax))
    ]
}

const clearNumber = (value = "") => {
    return value.replace(/\D+/g, "");
}

const formatCreditCardNumber = (value) => {
    if (!value) {
        return value;
    }

    const issuer = detectCreditCardType(value)
    const clearValue = clearNumber(value);
    let nextValue;

    switch (issuer) {
        case "amex":
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(10, 15)}`;
            break;
        case "dinersclub":
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4,10)} ${clearValue.slice(10, 14)}`;
            break;
        default:
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4,8)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
            break;
    }

    return nextValue.trim();
}

const formatCVC = (value, number) => {
    const clearValue = clearNumber(value);
    let maxLength = 4;

    if (number && number != "") {
        //const issuer = Payment.fns.cardType(allValues.number);
        const issuer = detectCreditCardType(number)
        maxLength = issuer === "amex" ? 4 : 3;
    }

    return clearValue.slice(0, maxLength);
}

const formatExpirationDate = (value) => {
    const clearValue = clearNumber(value);

    if (clearValue.length >= 3) {
        return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
    }

    return clearValue;
}

const detectCreditCardType = (cardNumber) => {
    const cardTypes = [
        {
            type: "visa",
            pattern: /^4[0-9]{12}(?:[0-9]{3})?$/
        },
        {
            type: "mastercard",
            pattern: /^5[1-5][0-9]{14}$/
        },
        {
            type: "amex",
            pattern: /^3[47][0-9]{13}$/
        },
        {
            type: "discover",
            pattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/
        },
        {
            type: "dinersclub",
            pattern: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/
        },
        {
            type: "jcb",
            pattern: /^(?:2131|1800|35\d{3})\d{11}$/
        }
        // Add more card types and patterns as needed
    ];

    for (const cardType of cardTypes) {
        if (cardType.pattern.test(cardNumber)) {
            return cardType.type;
        }
    }
    return "Unknown";
}
const validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export {
    validateEmail,
    calcSeason,
    getSeason,
    calcNights,
    seasonGuestsPrice,
    seasonExtrasPrice,
    perNight,
    perGuest,
    afterTaxes,
    calcRoomPrices,
    calcRoomPricesXdia,
    calcExtraPrice,
    calcTamborPrice,
    calcDiscount,
    getRoomGallery,
    getPackGallery,
    jumpTo,
    keyboardActive,
    keyboardHidden,
    printContents,
    buscaSeasonXDia,
    seteaCifra,
    calculaPorcentaje,
    formatCreditCardNumber,
    formatExpirationDate,
    formatCVC,
    detectCreditCardType
};
